__turbopack_context__.v({
  "done": "ReportDealForm-module__p1bOXa__done",
  "doneBody": "ReportDealForm-module__p1bOXa__doneBody",
  "doneTitle": "ReportDealForm-module__p1bOXa__doneTitle",
  "intro": "ReportDealForm-module__p1bOXa__intro",
  "panel": "ReportDealForm-module__p1bOXa__panel",
  "toggle": "ReportDealForm-module__p1bOXa__toggle",
  "wrapper": "ReportDealForm-module__p1bOXa__wrapper",
});
